import { render, staticRenderFns } from "./NewInvoice.vue?vue&type=template&id=a635f20c"
import script from "./NewInvoice.vue?vue&type=script&lang=js"
export * from "./NewInvoice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports